import {
  AUTO_PAYMENT_REQUEST,
  AUTO_PAYMENT_RESPONSE,
  PAYMENT_HISTORY_REQUEST,
  PAYMENT_HISTORY_RESPONSE,
  PRODUCT_BILLING_RECORDS_REQUEST,
  PRODUCT_BILLING_RECORDS_RESPONSE,
  PRODUCT_BILLING_STATUSES_REQUEST,
  PRODUCT_BILLING_STATUSES_RESPONSE,
  PRODUCT_ENTITLEMENTS_REQUEST,
  PRODUCT_ENTITLEMENTS_RESPONSE,
  VIRTUAL_ACCOUNT_HISTORY_REQUEST,
  VIRTUAL_ACCOUNT_HISTORY_RESPONSE,
} from '../actions/usageStatus.actions';

export default function usageStatus(
  state = {
    productEntitlements: [],
    virtualAccountHistories: [],
    paymentHistory: {content: [], pageNumber: 1, totalItemCount: 0},
    productBillingStatuses: {content: [], pageNumber: 1, totalItemCount: 0},
    productBillingRecords: {content: [], pageNumber: 1, totalItemCount: 0},
    autoPayment: {},
  },
  action
) {
  switch (action.type) {
    case PRODUCT_ENTITLEMENTS_REQUEST: {
      let nextState = {...state};
      nextState.productEntitlements = [];
      return state;
    }
    case PRODUCT_ENTITLEMENTS_RESPONSE: {
      let nextState = {...state};
      nextState.productEntitlements = action.productEntitlements;
      return nextState;
    }
    case PAYMENT_HISTORY_REQUEST: {
      let nextState = JSON.parse(JSON.stringify(state));
      nextState.paymentHistory.pageNumber = action.pageNumber;
      nextState.paymentHistory.startDate = action.startDate;
      nextState.paymentHistory.endDate = action.endDate;
      return nextState;
    }
    case PAYMENT_HISTORY_RESPONSE: {
      let nextState = JSON.parse(JSON.stringify(state));
      nextState.paymentHistory.content = action.content;
      nextState.paymentHistory.pageNumber = action.pageNumber;
      nextState.paymentHistory.totalItemCount = action.totalItemCount;
      return nextState;
    }
    case PRODUCT_BILLING_STATUSES_REQUEST: {
      let nextState = {...state};
      nextState.productBillingStatuses.pageNumber = action.pageNumber;
      nextState.productBillingStatuses.startDate = action.startDate;
      nextState.productBillingStatuses.endDate = action.endDate;
      return nextState;
    }
    case PRODUCT_BILLING_STATUSES_RESPONSE: {
      let nextState = {...state};
      nextState.productBillingStatuses.content = action.content;
      nextState.productBillingStatuses.totalItemCount = action.totalItemCount;
      return nextState;
    }
    case PRODUCT_BILLING_RECORDS_REQUEST: {
      let nextState = {...state};
      nextState.productBillingRecords.pageNumber = action.pageNumber;
      nextState.productBillingRecords.productEntitlementId = action.productEntitlementId;
      return nextState;
    }
    case PRODUCT_BILLING_RECORDS_RESPONSE: {
      let nextState = {...state};
      nextState.productBillingRecords.content = action.content;
      nextState.productBillingRecords.totalItemCount = action.totalItemCount;
      return nextState;
    }
    case AUTO_PAYMENT_REQUEST: {
      let nextState = {...state};
      nextState.autoPayment = {};
      return nextState;
    }
    case AUTO_PAYMENT_RESPONSE: {
      let nextState = {...state};
      nextState.autoPayment = action.autoPayment;
      return nextState;
    }
    case VIRTUAL_ACCOUNT_HISTORY_REQUEST: {
      let nextState = {...state};
      nextState.virtualAccountHistories = {};
      return nextState;
    }
    case VIRTUAL_ACCOUNT_HISTORY_RESPONSE: {
      let nextState = {...state};
      nextState.virtualAccountHistories = action.virtualAccountHistories;
      return nextState;
    }
  }
  return state;
}
